import { remove } from '../index';

export function removePost(obj) {
  return remove('/posts', obj);
}
